<template>
  <el-form-item :label="form.cname+':'"
    :key="form.key"
    :prop="prop"
    :rules="rule">
    <el-input v-if="status === 'edit'"
      v-model="form.fieldValue"></el-input>
    <span v-else>{{form.fieldValue || '&nbsp;' }}</span>
  </el-form-item>
</template>
<script>
export default {
  name: 'form-text',
  props: {
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    }
  },
  computed: {
    form: {
      get () {
        return this.item
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    rule () {
      return {
        required: this.form.mandatory,
        message: this.form.cname + '不能为空',
        trigger: 'blur'
      }
    }
  }
}
</script>
